import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TrainingComponent } from './training.component';
import { SelectDrillPopupComponent } from './select-drill-popup/select-drill-popup.component';


const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        component: TrainingComponent
      },
      {
        path: 'SelectDrillTraining',
        component: SelectDrillPopupComponent
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TrainingRoutingModule { }
